import CancelledReason from "@/models/Shared/CancelledReason";

export default class CancelledReasonViewModel {
    name: string;
    value: CancelledReason;
    public constructor(name: string, value: CancelledReason) {
        this.name = name;
        this.value = value;
    }
}